document.addEventListener('DOMContentLoaded', function() {
  // Function to handle video autoplay
  function setupVideoAutoplay() {
    // For regular HTML5 videos
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      // Set video attributes for autoplay
      video.muted = true;
      video.playsinline = true;
      video.loop = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'auto');
      
      // Properly handle the play promise
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Automatic playback started successfully
            console.log('Video autoplay successful');
          })
          .catch(error => {
            console.log('Autoplay prevented:', error);
            // Add click event to play on user interaction (fallback)
            document.addEventListener('click', () => {
              // Try playing again on user interaction
              video.play().catch(e => console.log('Play after click failed:', e));
            }, { once: true });
          });
      }
    });
    
    // For Shopify's deferred media component
    const deferredMedia = document.querySelectorAll('deferred-media');
    deferredMedia.forEach(media => {
      // Set data attribute for autoplay
      media.setAttribute('data-autoplay', 'true');
      
      // Handle the poster button with proper timing
      const posterButton = media.querySelector('.deferred-media__poster');
      if (posterButton) {
        // Store current scroll position
        const scrollPosition = window.scrollY;
        
        // Wait for everything else to initialize first
        setTimeout(() => {
          try {
            // Programmatically click without scrolling
            posterButton.click();
            
            // Restore scroll position to prevent jumping to video
            window.scrollTo({
              top: scrollPosition,
              behavior: 'instant'
            });
          } catch (e) {
            console.log('Could not auto-click poster button:', e);
          }
        }, 300);
      }
      
      // Handle video inside deferred media after it loads
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeName === 'VIDEO') {
                // Set video attributes
                node.muted = true;
                node.playsinline = true;
                node.loop = true;
                node.setAttribute('muted', '');
                node.setAttribute('playsinline', '');
                node.setAttribute('loop', '');
                
                // Handle play promise properly
                const playPromise = node.play();
                if (playPromise !== undefined) {
                  playPromise.catch(error => {
                    console.log('Deferred video autoplay prevented:', error);
                  });
                }
              }
            });
          }
        });
      });
      
      // Start observing the deferred-media element
      observer.observe(media, { childList: true, subtree: true });
    });
  }
  
  // Wait for everything to be ready before attempting autoplay
  setTimeout(setupVideoAutoplay, 100);
});

// Also run when the page is fully loaded (including images)
window.addEventListener('load', function() {
  // Try one more time after everything is loaded
  setTimeout(function() {
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      if (video.paused) {
        video.muted = true;
        video.play().catch(e => console.log('Final autoplay attempt failed:', e));
      }
    });
  }, 500);
});
